import React from 'react';
import Navbar from './components/layout/Navbar';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Services from './components/sections/Services';
import WhyUs from './components/sections/WhyUs';
import FeaturedWork from './components/sections/FeaturedWork';
import Founder from './components/sections/Founder';
import Testimonials from './components/sections/Testimonials';
import Contact from './components/sections/Contact';
import Footer from './components/layout/Footer';
import Preloader from './components/ui/Preloader';
import Chatbot from './components/ui/Chatbot';

function App() {
  return (
    <>
      <Preloader />
      <div className="min-h-screen bg-offwhite selection:bg-gold-500 selection:text-navy-900 overflow-x-hidden">
        <Navbar />
        <main className="relative">
          <Hero />
          <div className="relative z-10 shadow-[0_-50px_100px_rgba(13,27,42,0.5)] bg-offwhite">
            <About />
          </div>
          <Services />
          <WhyUs />
          <FeaturedWork />
          <Founder />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
        <Chatbot />
      </div>
    </>
  );
}

export default App;